<template>
  <Modal ref="modal" title="Rastreamento" cancelClass="none" okClass="none">
    <form class="export-container" @submit.prevent="handleSubmit">

      <div class="format-container">

        <Select :options="trakingCompanyOptions" :modelValue="trakingCompany"
          @update:modelValue="$event => (this.trakingCompany = $event)" legend="Selecione a empresa de rastreamento:" placeholder="Selecione . . . "
          :disabled="loading" />

        <Button @handle:click="" text="Salvar" color="primary" :disabled="loading" />
      </div>
    </form>
  </Modal>
</template>

<script>
import Button from '@/components/core/Button.vue'
import Modal from '@/components/core/Modal.vue'
import TrayArrowDown from 'icons/TrayArrowDown'
import Select from '@/components/core/Select.vue'

export default {
  name: 'updateCompanieTracking',
  components: {
    Modal,
    Button,
    TrayArrowDown,
    Select
  },
  props: {
    trakingCompanyOptions: {
      type: Array,
      default: [ { value: "", text: "Carregando empresas parceiras . . ." } ],
    },
    veiculo: {
      type: Object,
      default: {},
    },
    schema: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      loading: false,
      trakingCompany: ''
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    async handleSubmit() {
      this.loading = true
      if(!this.trakingCompany) {
        this.toast('Selecione uma empresa de rastreamento.')
        this.loading = false
        return
      }

      let params = { company_id: this.trakingCompany, schema: this.schema }
      await this.$http.patch(`${process.env.VUE_APP_URL_API_V2}/veiculo/rastreameto/update/${this.veiculo.id_veiculo}`, params)
      .then(response => {
        this.toast('Empresa vinculada cadastrada com sucesso!.')
        this.loading = false
      })
      .catch(err => {
          this.toast('Erro vincular empresa.')
          this.loading = false
      })

      this.$emit('load:table')
      this.close()
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>
